import cx from 'classnames'
import { Icon } from '@/components/Icon'
import styles from './Radio.module.css'

interface RadioProps {
  selected?: boolean
  size?: number
  completed?: boolean
  name?: string
  onSelect?: () => unknown
}

/**
 * A round radio indicator, with a check mark when completed.
 */
export function Radio({
  selected,
  completed,
  size = 24,
  name,
  onSelect,
}: RadioProps) {
  const iconSize = size * 0.69

  return (
    <div
      className={cx(styles.root, selected && styles.selected)}
      style={{ width: size, height: size }}
    >
      {completed ? (
        <Icon size={iconSize} color="var(--brand-primary)" name="checkmark" />
      ) : (
        <input
          type="radio"
          name={name}
          className={styles.radio}
          checked={selected}
          readOnly={!onSelect}
          onChange={onSelect}
        />
      )}
    </div>
  )
}
